module.exports = {
      id: "gallery-whitebg-usage",
      viewBox: "0 0 90 90",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#gallery-whitebg",
      toString: function () {
        return this.url;
      }
    }